export const kebabToSnake = (str: string): string => str.replace(/-/g, "_");
